<template>
  <a
    class="save-star save-clip-star active"
    v-if="isSaved"
    @click.prevent="unSave(clip)"
    :data-id="clip"
  >
    <slot name="saved"></slot>
  </a>
  <a class="save-star save-clip-star" v-else @click.prevent="save(clip)" :data-id="clip">
    <slot name="unsaved"></slot>
  </a>
</template>

<script>
export default {
  props: ["clip", "saved"],

  data: function() {
    return {
      isSaved: ""
    };
  },

  mounted() {
    this.isSaved = this.isSave ? true : false;
  },

  computed: {
    isSave() {
      return this.saved;
    }
  },

  methods: {
    save(clip) {
      axios
        .post(this.route('clip.save',{clip:clip}))
        .then(response => {
          this.isSaved = true;
        })
        .catch(response => console.log(response.data));
    },

    unSave(clip) {
      axios
        .post(this.route('clip.unsave',{clip:clip}))
        .then(response => (this.isSaved = false))
        .catch(response => console.log(response.data));
    }
  }
};
</script>